import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeHomeschoolMaxWebinarFields {
  internalTitle: EntryFieldTypes.Symbol
  webinarTitle: EntryFieldTypes.Symbol
  shortDescription: EntryFieldTypes.Symbol
  thumbnail?: EntryFieldTypes.AssetLink
  webinarVideo: EntryFieldTypes.AssetLink
  webinarOverview?: EntryFieldTypes.RichText
  slug: EntryFieldTypes.Symbol
  transcript?: EntryFieldTypes.AssetLink
}

export type TypeHomeschoolMaxWebinarSkeleton = EntrySkeletonType<TypeHomeschoolMaxWebinarFields, 'homeschoolMaxWebinar'>
export type TypeHomeschoolMaxWebinar<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeHomeschoolMaxWebinarSkeleton,
  Modifiers,
  Locales
>

export function isTypeHomeschoolMaxWebinar<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeHomeschoolMaxWebinar<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'homeschoolMaxWebinar'
}

export type TypeHomeschoolMaxWebinarWithoutLinkResolutionResponse = TypeHomeschoolMaxWebinar<'WITHOUT_LINK_RESOLUTION'>
export type TypeHomeschoolMaxWebinarWithoutUnresolvableLinksResponse =
  TypeHomeschoolMaxWebinar<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeHomeschoolMaxWebinarWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> =
  TypeHomeschoolMaxWebinar<'WITH_ALL_LOCALES', Locales>
export type TypeHomeschoolMaxWebinarWithAllLocalesAndWithoutLinkResolutionResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeHomeschoolMaxWebinar<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeHomeschoolMaxWebinarWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeHomeschoolMaxWebinar<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
